"use client";

import { useNavigate } from "react-router-dom";
import { useState } from "react";

import { createSupabaseBrowserClient } from "@/lib/supabase/client";
import { useSession } from "@/session/session-context";

export function SignOutButton({ className }: { className?: string }) {
  const navigate = useNavigate();
  const { refresh } = useSession();
  const [busy, setBusy] = useState(false);

  async function signOut() {
    setBusy(true);
    try {
      await createSupabaseBrowserClient().auth.signOut();
      await refresh();
      navigate("/dashboard");
    } finally {
      setBusy(false);
    }
  }

  return (
    <button
      type="button"
      disabled={busy}
      onClick={() => void signOut()}
      className={
        className ??
        "rounded-lg border border-zinc-200 bg-white px-3 py-1.5 text-xs font-semibold text-zinc-800 shadow-sm transition hover:bg-zinc-50 disabled:opacity-60"
      }
    >
      {busy ? "Signing out…" : "Sign out"}
    </button>
  );
}
